/** @format */

import React from "react";
import { useHistory } from "react-router";

interface Props {
  to: string;
  className?: string;
  title?: string;
  children: React.ReactNode;
}

/**
 * Collegamento interno: un vero <a href> (si apre anche in una nuova scheda) che naviga con la
 * history di "react-router", come UILink. Il Link di react-router-dom qui non si usa: nel progetto
 * react-router-dom ha una sua copia di react-router e il suo contesto non è quello dell'app.
 */
export const Collegamento = ({ to, className, title, children }: Props): JSX.Element => {
  const history = useHistory();
  return (
    <a
      href={to}
      className={className}
      title={title}
      onClick={(e): void => {
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        history.push(to);
      }}
    >
      {children}
    </a>
  );
};
